exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".h3{\n    margin-top: 20px;\n    margin-bottom: 10px;\n    font-size: 24px;\n}\n\ntable{\n    text-align: center;\n}\n\n.list-group{\n    text-align: center;\n}\n\n.list-group-item{\n    display: block;\n    margin: 10px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/mmam/angular/src/app/privacy-policy/privacy-policy.component.css
// module id = ../../../../../src/app/privacy-policy/privacy-policy.component.css
// module chunks = main